import React, { useEffect, useState } from "react";
import History from "@irati/utils/history";
import { DealCategoryType } from "@irati/types";
import authentication from "@irati/auth";
import categoriesService from "@irati/deals/services/dealCategory";
import Button from "@irati/ui/src/Button";
import { FormattedMessage } from "@irati/utils/lang";
var SuccessButton = function (_a) {
    var onComplete = _a.onComplete, isInDeal = _a.isInDeal;
    var _b = useState(undefined), earnCategory = _b[0], setEarnCategory = _b[1];
    useEffect(function () {
        categoriesService.listForCurrentPackage().then(function (categories) {
            var perksGoCategory = categories.filter(function (category) { return category.type === DealCategoryType.Earn; })[0];
            setEarnCategory(perksGoCategory);
        });
    }, []);
    var handleRedirectToPerksGoCategory = function () {
        if (earnCategory) {
            History.push({ pathname: "/perks/categories/" + earnCategory.url });
        }
    };
    if (isInDeal) {
        return (React.createElement(Button, { onClick: onComplete, primary: true, large: true, full: true },
            React.createElement(FormattedMessage, { id: "perksgo.popup.linkCard.success.buttons.backToPerk" })));
    }
    if (authentication.apps("platform.geoLocation") && !!earnCategory) {
        return (React.createElement(Button, { primary: true, large: true, full: true, onClick: handleRedirectToPerksGoCategory },
            React.createElement(FormattedMessage, { id: "perksgo.popup.linkCard.success.buttons.browse" })));
    }
    return (React.createElement(Button, { onClick: onComplete, primary: true, large: true, full: true },
        React.createElement(FormattedMessage, { id: "perksgo.popup.linkCard.success.buttons.finish" })));
};
export default SuccessButton;
